<script setup lang="ts">
import { GTMMenuType } from '~/lib/models/gtm'
import { ButtonNavigation } from '~/lib/models/ui/bottom-navigation'

const layoutStore = useLayoutStore()
const props = defineProps<{ buttonNavigation: ButtonNavigation }>()
const route = useRoute()
const { profileRoute, restaurantsRoute, myOrdersRoute } = useMcdRoutes()
const { trackMenuClick } = useGTM()

const contentAccount = { tKey: 'onboarding.stepAccount', action: true, isLast: false }

const isHomePath = computed(() => props.buttonNavigation.path === '/')

const isRouteHomeActive = computed(() => {
  if (!isHomePath.value) return false
  const routeName = route.name
  if (routeName === 'restaurants-citySlug-restaurantSlug-orders') return true
  return false
})

const isAccountBtn = computed(() => props.buttonNavigation.path === profileRoute())

// menu_<event> being event like: home, my_account, my_orders, restaurants (by the moment)
const onClickMenuItem = () => {
  const path = props.buttonNavigation.path
  let menuItem = ''

  switch (true) {
    case isHomePath.value:
      menuItem = GTMMenuType.HOME
      break
    case isAccountBtn.value:
      menuItem = GTMMenuType.MY_ACCOUNT
      break
    case path === restaurantsRoute():
      menuItem = GTMMenuType.RESTAURANTS
      break
    case path === myOrdersRoute():
      menuItem = GTMMenuType.MY_ORDERS
      break
  }

  if (menuItem) {
    trackMenuClick(menuItem)
  }
}
</script>

<template>
  <div v-if="buttonNavigation.path === '/more'">
    <button
      class="flex h-full flex-col items-center justify-between"
      @click="layoutStore.openMenuSideBar()"
    >
      <img class="h-8 w-8" :src="buttonNavigation.icon" :alt="buttonNavigation.title" />
      <p class="text-[10px] font-normal text-mcd-secondaryDarkGrey">
        {{ buttonNavigation.title }}
      </p>
    </button>
  </div>

  <NuxtLink
    v-else-if="!isAccountBtn"
    :to="buttonNavigation.path"
    class="grayscale-[1] filter"
    :class="{ 'router-link-active': isHomePath && isRouteHomeActive }"
    @click="onClickMenuItem"
  >
    <div class="flex h-full flex-col items-center justify-between">
      <img class="h-8 w-8" :src="buttonNavigation.icon" :alt="buttonNavigation.title" />
      <p class="bottom-bar-title text-[10px] font-normal text-mcd-secondaryDarkGrey">
        {{ buttonNavigation.title }}
      </p>
    </div>
  </NuxtLink>

  <PopperWrapper v-else data-popper="stepAccount" placement="top">
    <template #default="{ isShowed }">
      <NuxtLink
        :to="buttonNavigation.path"
        :class="{
          'router-link-active': (isHomePath && isRouteHomeActive) || isShowed,
          'grayscale-[1] filter': !isShowed,
        }"
        @click="onClickMenuItem"
      >
        <div class="flex h-full flex-col items-center justify-between">
          <img class="h-8 w-8" :src="buttonNavigation.icon" :alt="buttonNavigation.title" />
          <p class="bottom-bar-title text-[10px] font-normal text-mcd-secondaryDarkGrey">
            {{ buttonNavigation.title }}
          </p>
        </div>
      </NuxtLink>
    </template>
    <template #content="{ close }">
      <McdPopper :close="close" :content="contentAccount" />
    </template>
  </PopperWrapper>
</template>

<style>
.router-link-active {
  @apply filter-none;
}

.router-link-active .bottom-bar-title {
  @apply font-bold text-mcd-black;
}
</style>
